import { Link } from 'react-router-dom'

export const NotFound = () => {
  return (
    <div>
      <h1>Oops! You seem to be lost.</h1>
      <p>
        Go back to <Link to="/">Home</Link>
      </p>
    </div>
  )
}
